/* eslint-disable @typescript-eslint/no-explicit-any */
import prodEnv from './env-prod';
import devEnv from './env-dev';
import stageEnv from './env-stage';
import { IEnv } from './interface';
import { APP_ENV } from './common/utils';

let CurrentEnv: any = {};

if (APP_ENV.dev) {
  CurrentEnv = devEnv;
} else if (APP_ENV.stage) {
  CurrentEnv = stageEnv;
} else if (APP_ENV.prod) {
  CurrentEnv = prodEnv;
} else if (APP_ENV.test) {
  CurrentEnv = devEnv;
}

export const PROJECT_ENVIRONMENT: IEnv = Object.assign({}, CurrentEnv);
